import styled, { css } from 'styled-components';
import theme from '../../../../theme';

const ButtonContained = styled.button<{
    $primaryColor: boolean;
}>`
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${({ $primaryColor }) => $primaryColor ? theme.white : '#0472B7'};
    background-color: ${({ $primaryColor }) => $primaryColor ? '#0472B7' : theme.white};
    padding: 12px 24px;
    border: none;
    border-radius: 60px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 700;

    svg {
        margin-right: 5px;
    }

    &:disabled {
        background-color: #0472B7;
        color: ${theme.white};
        cursor: default;
        opacity: 0.7;
    }

    &:hover {
        ${({ $primaryColor }) => $primaryColor ? css`
            background-color: rgba(4,114,183, 0.9);
        ` : css``
        };
        -webkit-transition: 0.3s;
        -moz-transition: 0.3s;
        -ms-transition: 0.3s;
        -o-transition: 0.3s;
        transition: 0.3s;
    }
`;

const ButtonOutlined = styled(ButtonContained)`
    color: #0472B7 !important;
    background-color: transparent;
    border: 2px solid #0472B7;
    padding: 10px 24px;

    &:disabled {
        border: 2px solid #0472B7;
        background-color: transparent;
    }

    &:hover {
        background-color: transparent;
    }
`;

const ButtonLabel = styled(ButtonContained)`
    color: #0472B7;
    background-color: transparent;
    border: 2px solid transparent;
    padding: 10px 24px;
    
    &:disabled {
        border: 2px solid transparent;
    }

    &:hover {
        background-color: transparent;
    }
`;

export { ButtonContained, ButtonOutlined, ButtonLabel };